<script>
import { Icon } from "vant";
import moment from "moment";
import DateTimePicker from "@/components/date-time-picker/function";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: Array,
      default: () => [],
    },
    min: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      minDate: "",
      maxDate: "",
    };
  },
  created() {
    this.copyData();
    if (this.defaultValue && this.defaultValue.length > 1) {
      this.startDate = this.defaultValue[0];
      this.endDate = this.defaultValue[1];
      this.$emit("update", this.defaultValue);
    }
    this.minDate = this.min;
    this.maxDate = this.max;
  },
  methods: {
    handleStartDateClick(/*type*/) {
      const that = this;
      DateTimePicker({
        value: that.startDate,
        format: "YYYY-MM-DD",
        minDate: that.minDate,
        maxDate: that.maxDate,
        change: that.setStartDate,
      });
    },
    handleEndDateClick(/*type*/) {
      const that = this;
      DateTimePicker({
        value: that.endDate,
        format: "YYYY-MM-DD",
        minDate: that.minDate,
        maxDate: that.maxDate,
        change: that.setEndDate,
      });
    },
    setStartDate(value) {
      this.startDate = value;
      // this.minDate = value;
      // this.maxDate = this.max;
      if (moment(this.endDate).isBefore(this.startDate, "day")) {
        this.endDate = this.startDate;
      }
      this.updateData();
    },
    setEndDate(value) {
      this.endDate = value;
      // this.minDate = "";
      // this.maxDate = value;
      if (moment(this.endDate).isBefore(this.startDate, "day")) {
        this.startDate = this.endDate;
      }
      this.updateData();
    },
    setValue(value) {
      this.copyData(value);
    },
    copyData(val) {
      const value = val ? val : this.value;
      const dates = cloneDeep(value);
      if (dates && dates.length > 1) {
        this.startDate = dates[0];
        this.endDate = dates[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }
    },
    updateData() {
      const json = [];
      if (this.startDate) {
        json.push(this.startDate);
      }
      if (this.endDate) {
        json.push(this.endDate);
      }
      this.$emit("update", json);
    },
  },
  render() {
    return (
      <div class="date-range-picker">
        <div class="item" {...{ on: { click: this.handleStartDateClick } }}>
          <van-icon class="item-icon" name="calender-o" />
          {this.startDate}
        </div>
        <div class="fh"> - </div>
        <div class="item" {...{ on: { click: this.handleEndDateClick } }}>
          <van-icon class="item-icon" name="calender-o" />
          {this.endDate}
        </div>
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
.date-range-picker {
  display: flex;
  font-size: 14px;
  .item {
    flex: 1;
    padding: 10px;
    background: #f1f1f1;
    border-radius: 4px;
    .item-icon {
      margin-right: 6px;
    }
  }
  .fh {
    padding: 0 10px;
    line-height: 40px;
  }
}
</style>
